<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="6" sm="8">
        <v-card class="elevation-12" style="padding: 10px">
          <v-card-title>{{ $tt('ResetPasswordTitle') }}</v-card-title>
          <v-card-text>{{ $tt('ResetPasswordDescription') }}</v-card-text>
          <v-form lazy-validation ref="form" v-model="valid">
            <v-card-text>
              <v-text-field
                :error-messages="emailErrors"
                :label="$tt('customEmail')"
                @blur="$v.email.$touch()"
                @input="$v.email.$touch()"
                placeholder="you@example.com"
                required
                v-model="email"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn :disabled="!valid" @click.stop="resetPassword" block class="white--text text-none" color="error">
                {{ $tt('ResetPasswordButton') }}
              </v-btn>
            </v-card-actions>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn :to="{ name: 'Login' }" class="text-none" text>{{ $tt('customGoToLoginPageTitle') }}</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Toast from '@/lib/toast'
import router from '@/router'
import { validationMixin } from 'vuelidate'
import { email, required } from 'vuelidate/lib/validators'
import connectAuthClient from '@/lib/connect-client/connect-auth-client'

export default {
  name: 'user-reset-password',
  mixins: [validationMixin],

  validations: {
    email: { required, email },
  },

  data: () => ({
    email: null,
    valid: true,
  }),

  computed: {
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push(this.$tt('ValidationBadEmail'))
      !this.$v.email.required && errors.push(this.$tt('ValidationTextRequired'))
      return errors
    },
  },

  methods: {
    resetPassword() {
      // Do validation
      this.$v.$touch()
      if (this.$v.$error) {
        console.error('Validation Error')
        return
      }
      connectAuthClient
        .resetPassword(this.email)
        .then(response => {
          router.push({ name: 'Login' })
          Toast.i18nSuccess('customSentEMailMessage')
        })
        .catch(error => {
          if (error.response) {
            console.error(error.response)
            const message = error.response.data.message
            Toast.error(message)
          } else {
            Toast.error('reset failed.')
          }
        })
    },
  },
}
</script>
